export const CHECK_RESULT_RATING_MAIL_REQUEST = 'CHECK_RESULT_RATING_MAIL_REQUEST';

export const checkResultRatingMailRequest = () => ({
    type: CHECK_RESULT_RATING_MAIL_REQUEST,
});
